import React, {useState} from 'react';
import s from '../MyOrdersForManager.module.css';
import {OrderInfo} from '../../../types/TypesUserOrders';
import {useTranslation} from 'react-i18next';
import TableFullViewProductEl from '../../../Components/TableCommonDirectory/TableElements/TableFullViewProductEl';
import {orderStatusTranslate} from '../../../assets/utils/translatersFunc';
import OrdersActions from './OrdersActions';
import StoreOrdersActions from './StoreOrdersActions';

export type OrderRowType = 'list-store' | 'order';

type Props = {
	order: OrderInfo;
	index: number;
	type: OrderRowType;
};
const OrderRowElNew: React.FC<Props> = ({order, index, type}) => {
	const [openOrder, setOpenOrder] = useState<number | null>(null);
	const {t} = useTranslation();
	const {id, pay_money, status, status_pay, deferred, create_date, order_date, points, ware_name, initial_name} = order;
	const active = openOrder === id;

	const handleClickOpen = () => {
		setOpenOrder(openOrder !== id ? id : null);
	};

	// Рендер для типа 'order'
	const renderOrderType = () => (
		<>
			<div 
				className={s.tableEl}
				role={'button'}
				tabIndex={0}
				onClick={handleClickOpen}
				style={{cursor: 'pointer'}}
			>
				{id}
			</div>
			<div className={s.tableEl}>{create_date.split('T')[0]}</div>
			<div className={s.tableEl}>{pay_money}</div>
			<div className={s.tableEl}>{orderStatusTranslate(status)}</div>
			<div className={s.tableEl}>
				{status_pay ? t('Оплачено') : t('Не оплачено')}
			</div>
			<div className={`${s.tableEl} ${s.actions}`}>
				<OrdersActions order={order} />
			</div>
			<div className={s.tableEl}>
				{deferred ? t('Відкладене') : t('Звичайне')}
			</div>
		</>
	);

	// Рендер для типа 'list-store'
	const renderListStoreType = () => (
		<>
			<div 
				className={s.tableEl}
				role={'button'}
				tabIndex={0}
				onClick={handleClickOpen}
				style={{cursor: 'pointer'}}
			>
				{id}
			</div>
			<div className={s.tableEl}>{order_date.split('T')[0]}</div>
			<div className={s.tableEl}>{points}</div>
			<div className={s.tableEl}>{ware_name}</div>
			<div className={s.tableEl}>{orderStatusTranslate(status)}</div>
			<div className={`${s.tableEl} ${s.actions}`}>
				<StoreOrdersActions order={order} />
			</div>
			<div className={s.tableEl}>{initial_name}</div>
		</>
	);

	return (
		<div className={s.tableContainer}>
			<div className={`${s.tableRow} ${s.greenHover}`}>
				<div
					className={s.tableEl}
					role={'button'}
					tabIndex={0}
					onClick={handleClickOpen}
				>
					<div className={`shopping__1 ${active && 'active'}`}> </div>
					<div className={s.indexContainer}>{index + 1}</div>
				</div>
				{type === 'order' ? renderOrderType() : renderListStoreType()}
			</div>
			<TableFullViewProductEl order={order} active={active} />
		</div>
	);
};

export default OrderRowElNew;
